export const SITE_URL = "https://innertruth.co.in";
export const PHONE = "+919845867872";
export const PHONE_DISPLAY = "+91 98458 67872";
export const WHATSAPP_LINK = `https://wa.me/919845867872`;
export const EMAIL = "shyaam61@gmail.com";
export const BUSINESS_NAME = "InnerTruth";
export const LOCATION = "Malleshwaram, Bengaluru, Karnataka";
export const ADDRESS = "116/2, Near 11th Cross Road, Adjacent to Union Bank, Malleshwaram, Bengaluru, Karnataka 560003";
export const MAPS_LINK = "https://www.google.com/maps/search/116+2+near+11th+cross+road+adjacent+to+union+bank+Malleshwaram+Bengaluru+Karnataka+560003";
